export default __webpack_public_path__ + "static/media/Visa_Inc._logo.svg.37d74a0c.png";